import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const BangladeshSubsidiary = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to the top of the page when component mounts
  }, []);

    const [services, setServices] = useState([]); // State to store services
    const [loading, setLoading] = useState(true); // State for loading indicator
  
    useEffect(() => {
      // Fetch services data
      const fetchServices = async () => {
        try {
          const response = await axios.get(
            "https://mirai-server.vercel.app/service-main"
          );
          setServices(response.data); // Update state with fetched data
          setLoading(false); // Set loading to false after data is fetched
        } catch (error) {
          console.error("Error fetching services:", error);
          setLoading(false);
        }
      };
  
      fetchServices();
    }, []);
  return (
    <div>
      <div className="text-justify lg:py-20 sm:py-5 min-h-screen border-t border-blue-200">
        <div className="text-justify w-full  max-w-screen-2xl mx-auto p-4 ">
          <h1 className="text-justify lg:text-5xl sm:text-2xl font-semibold font-jost customBlue">
            Company Profile
          </h1>
          <div className="text-justify mt-2">
            <h1 className="text-justify text-2xl mt-10  font-jost text-gray-900">
              Mirai Consulting Bangladesh Ltd.
            </h1>
            <div className="text-justify mt-5">
              <div className="text-justify mt-5">
                <table>
                  <tr className=" border border-gray-600 text-start font-jost text-gray-600 text-lg">
                    <td className=" border-r border-gray-600">
                       Company Name
                    </td>
                    <td className=" border-r border-gray-600">
                      MIRAI Consulting Bangladesh Ltd.
                    </td>
                   
                  </tr>
                  <tr className=" border border-gray-600 text-start font-jost text-gray-600 text-lg">
                    <td className=" border-r border-gray-600">
                      Representative
                    </td>
                    <td className=" border-r border-gray-600">
                       Kanai Kenichi, Japan CPA <br/>
                       MD Shakil Ahmed, Business Chief Consultant
                    </td>
                 
                  </tr>
                  <tr className=" border border-gray-600 text-start font-jost text-gray-600 text-lg">
                    <td className=" border-r border-gray-600">
                    Establishment
                    </td>
                    <td className=" border-r border-gray-600">
                    July 4, 2024
                    </td>
                  
                 
                  </tr>
                  <tr className=" border border-gray-600 text-start font-jost text-gray-600 text-lg">
                    <td className=" border-r border-gray-600">
                    URL
                    </td>
                    <td className=" text-blue-500 border-none  flex flex-col gap-1">
                  <a href="https://www.miraicbd.com/" target="_blank" >
                  https://www.miraicbd.com/
                  </a>
                  </td>
                 
                  </tr>
                  <tr className=" border border-gray-600 text-start font-jost text-gray-600 text-lg">
                    <td className=" border-r border-gray-600">
                    Location
                    </td>
                    <td className=" border-r border-gray-600">
                    Bari Momen's Heights, Plot-157, Flat 9A, Road-12, Block-E, Banani, Dhaka-1213, Bangladesh
                    </td>
                 
                  </tr>
                  <tr className=" border border-gray-600 text-start font-jost text-gray-600 text-lg">
                    <td className="border-none  flex justify-start ">
                    Services
                    </td>
                    <td className=" border-r border-l border-gray-600">
          
                    {services.map((service) => (
                                                <ul className="">
                                                  <li >
                                                    <Link to={`/service/${service._id}`}>
                                                      {service.service}
                                                    </Link>
                                                  </li>
                                                </ul>
                                              ))}
                    </td>
                 
                  </tr>
                </table>
              </div>
            </div>
          </div>
          <h1 className="text-justify lg:text-2xl sm:text-2xl mt-10 font-semibold font-jost customBlue">
            Mirai Consulting Bangladesh Office
          </h1>
          <div className="text-justify flex lg:flex-row sm:flex-col gap-5 mt-5  rounded">
            <div>
              <div className="text-justify flex flex-col  gap-3">
                <h1 className="text-justify font-jost text-lg font-semibold customBlue">
                  Location:
                </h1>
                <p className="text-justify font-jost text-lg customBlue">
                Bari Momen's Heights, Plot-157, Flat 9A, Road-12, Block-E, Banani, Dhaka-1213, Bangladesh
                </p>
              </div>
              <div className="text-justify flex flex-col   gap-3 mt-10">
                <h1 className="text-justify font-jost text-xl font-semibold customBlue">
                  Access:
                </h1>
                <div className="text-justify flex flex-col">
                  <p className="text-justify font-jost text-lg customBlue">
                    <span className="text-justify font-semibold">
                      Public Transport:
                    </span>{" "}
                    <br></br> Direct Public Bus (Gulshan Chaka) from Gulshan 2
                    Bus Stop to Banani Kakoli Bus Stop, followed by a 10-minutes
                    walk through Kamal Ataturk Avenue to Road 12.
                  </p>
                  <p className="text-justify font-jost text-lg customBlue mt-5">
                    <span className="text-justify font-semibold">
                      Private Transport:
                    </span>{" "}
                    <br></br> 10-minutes drive from Gulshan 2 circle through
                    Kamal Ataturk Avenue to Road 12.
                  </p>
                </div>
              </div>
            </div>
            <div className="text-justify w-full rounded-xl bg-gray-100">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d462.23595252826965!2d90.4078842287267!3d23.792821682500335!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3755c70959f08483%3A0xacf5fee9efebc8b1!2sBari%20Momen%E2%80%99s%20Heights!5e0!3m2!1sen!2sbd!4v1733946008030!5m2!1sen!2sbd"
                width="100%"
                height="450"
                style={{ border: 0, borderRadius: "10px" }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BangladeshSubsidiary;
